import { createElementVNode as _createElementVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-720ede9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "phone-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "auth-phone",
  class: "base-label phone-form__title"
}, "Телефон", -1))
const _hoisted_3 = {
  key: 0,
  class: "input-error"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "captcha-container",
  class: "captcha"
}, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "input-error"
}
const _hoisted_6 = { class: "phone-form__confirmation" }
const _hoisted_7 = {
  for: "processing-personal-data",
  class: "checkbox"
}
const _hoisted_8 = { class: "checkbox__label phone-form__confirmation-message" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Войти с помощью", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "phone-form__motmom-icon" }, null, -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currPhone) = $event)),
      placeholder: "+7 (xxx) xxx-xx-xx",
      name: "auth-phone",
      class: "phone-form__input base-input base-input--black",
      onMaska: _cache[1] || (_cache[1] = ($event: any) => (_ctx.phone = `+7${$event.target.dataset.maskRawValue}`)),
      onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.$filters.replaceFirstEight && _ctx.$filters.replaceFirstEight(...args)))
    }, null, 544), [
      [_vModelText, _ctx.currPhone],
      [_directive_maska, _ctx.mask]
    ]),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true),
    (_ctx.isVisibleCaptcha)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_4,
          (_ctx.captchaError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.captchaError), 1))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("label", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          id: "processing-personal-data",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isConfirmed) = $event)),
          type: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, _ctx.isConfirmed]
        ]),
        _createElementVNode("span", _hoisted_8, [
          _createTextVNode(" Настоящим, я принимаю условия "),
          (_ctx.companyStore.documentsUrls[_ctx.DOCUMENT_TYPE.PRIVACY_POLICY])
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _ctx.companyStore.documentsUrls[_ctx.DOCUMENT_TYPE.PRIVACY_POLICY],
                target: "_blank",
                rel: "noreferrer noopener"
              }, "Политики конфиденциальности", 8, _hoisted_9))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("Политики конфиденциальности")
              ], 64)),
          _createTextVNode(" и "),
          (_ctx.companyStore.documentsUrls[_ctx.DOCUMENT_TYPE.CONTRACT_OFFER])
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                href: _ctx.companyStore.documentsUrls[_ctx.DOCUMENT_TYPE.CONTRACT_OFFER],
                target: "_blank",
                rel: "noreferrer noopener"
              }, "Договора публичной оферты по оказанию услуг", 8, _hoisted_10))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createTextVNode("Договора публичной оферты по оказанию услуг")
              ], 64)),
          _createTextVNode(" и даю своё согласие на обработку моих персональных данных, в соответствии с Федеральным законом от 27.07.2006 года №152-ФЗ «О персональных данных», на условиях, в порядке, в сроки и для целей, определенных "),
          (_ctx.companyStore.documentsUrls[_ctx.DOCUMENT_TYPE.PRIVACY_POLICY])
            ? (_openBlock(), _createElementBlock("a", {
                key: 4,
                href: _ctx.companyStore.documentsUrls[_ctx.DOCUMENT_TYPE.PRIVACY_POLICY],
                target: "_blank",
                rel: "noreferrer noopener"
              }, "Политики конфиденциальности", 8, _hoisted_11))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                _createTextVNode("Политики конфиденциальности")
              ], 64)),
          _createTextVNode(". ")
        ])
      ])
    ]),
    _createElementVNode("button", {
      class: _normalizeClass(["phone-form__get-code-btn base-btn base-btn--black", {
        'base-btn--disabled': !_ctx.isSendCodeAllowed,
      }]),
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
    }, " Получить код ", 2),
    _createElementVNode("a", {
      class: "phone-form__motmom-sign-in",
      href: _ctx.moAuthUrl
    }, _hoisted_15, 8, _hoisted_12)
  ]))
}